// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__20Q7I","content":"styles_content__1AF7D","checkbox":"styles_checkbox__1vlEZ","checkboxLabel":"styles_checkboxLabel__2ZNRx"};